import Swiper, { Navigation, Pagination, Lazy, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const sliderMain = document.querySelector(".js-slider-main-init");

if (sliderMain) {
    const slides = sliderMain.querySelectorAll(".swiper-slide");

    if (slides && slides.length > 1) {
        new Swiper(".js-slider-main-swiper-container", {
            loop: true,
            speed: 300,
            watchSlidesVisibility: true,
            preloadImages: true,
            lazy: {
                elementClass: "lazyload",
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                loadedClass: "swiper-lazyloaded",
                loadingClass: "swiper-lazyloading",
            },
            pagination: {
                el: ".js-slider-main-swiper-controls > .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".js-slider-main-swiper-controls > .swiper-button-next",
                prevEl: ".js-slider-main-swiper-controls > .swiper-button-prev",
            },
        });
    }
}
